import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetPooyanPlayerTokenResponse } from '@/Module/Lesson/Model/ApiModel';
import { getPooyanPlayTokenAction } from '@/Module/Lesson/Store/Action';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { setForceAsiatechAction } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import type { IState } from '@/Module/Store/Model';

export const updateLessonPooyanPlayTokenAction = createAsyncThunk<IGetPooyanPlayerTokenResponse>(
  'lessonSection/updateLessonPooyanPlayToken',
  async (_, { dispatch, getState, rejectWithValue }) => {
    const lessonSection = selectedLessonSectionSelector(getState() as IState);
    if (lessonSection?.providerId !== 1) {
      dispatch(setForceAsiatechAction(false));
      return rejectWithValue('not pooyan video, no need update pooyan video');
    }

    if (!lessonSection?.mediaLink2) {
      dispatch(setForceAsiatechAction(true));
      return rejectWithValue('contentId not available, switched to Asiatech!');
    }

    return dispatch(getPooyanPlayTokenAction(lessonSection.mediaLink2))
      .unwrap()
      .catch(() => {
        dispatch(setForceAsiatechAction(true));
        return rejectWithValue('pooyan not available, switched to Asiatech!');
      });
  },
);
